// import {_Product} from '@/types/type'
import Image from 'next/image'
import AddToCart from '../cart/add-to-cart';
import { ProductType } from '../product-shops/ShopList';
import { useRouter } from "next/navigation";
import FavoriteButton from '../FavoriteButton';

type Props = {
    product: ProductType
    markFavorite?: (is_favorite: boolean) => void;
}

export default function ProductCard({product, markFavorite}: Props) {
    const router = useRouter();
    return (
        <div className='rounded'>
            <a key={product.id} onClick={() => router.push(`/shop/${product.id}`)} className="group">
                <div
                    className="aspect-h-1 aspect-w-1 w-full overflow-hidden rounded-lg bg-gray-200 xl:aspect-h-8 xl:aspect-w-7">
                    <Image
                        src={product.image_url}
                        alt={product.imageAlt}
                        width={500}
                        height={500}
                        className="h-full w-full object-cover object-center group-hover:opacity-75"
                    />

                    {markFavorite && (
                        <FavoriteButton 
                            id={product.id}
                            is_favorite={product.is_favorite}
                            markFavorite={(is_favorite) => markFavorite(is_favorite)}
                        />
                    )}

                </div>
            </a>
            <div>
                <h3 className="mt-4 text-sm text-gray-700">{product.name}</h3>
                <p className="mt-1 text-lg font-medium text-gray-900">{new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(product.price)}</p>
                <AddToCart product={product}/> 
            </div>           
        </div>
    )
}